
import GenericTemplateHistoryEdition from "./GenericTemplateHistoryEdition";

export default GenericTemplateHistoryEdition;